/**
 * Fetches footer links from the CMS based on the provided delivery key.
 *
 * @async
 * @function useFooter
 * @param {string} deliveryKey - The unique key used to retrieve footer content.
 * @returns {Promise<Object>} An object containing footer link data and a refresh method.
 * @property {Object} data - The fetched footer links data.
 * @property {Function} refresh - A method to refresh the footer links data.
 *
 * @example
 * // Fetch footer links for a specific delivery key
 * const { data, refresh } = await useFooter('homepage_footer')
 *
 * @throws {Error} Will throw an error if the API request fails.
 */
export async function useFooter(deliveryKey: string) {
  const localePath = useLocalePath()

  const query = {
    locale: localePath(''),
    vse: useRoute().query.vse,
    contentId: useRoute().query.contentId,
    deliveryKey: deliveryKey,
  }

  const { data, refresh } = await useFetch('/api/cms/getFooterLinks', {
    query,
  })

  return {
    data,
    refresh,
  }
}
